export const RoutesName = {
  KONTO: ":konto",
  ORG_FORM_MED_MOMS: ":orgForm/:medMva",
  ORG_FORM_MED_MVA_KONTO: ":orgForm/:medMva/:kontonummer",
  NO_MATCH: "*",
}
